// Module
var code = `<button class="user-item"> <img/> <span></span> </button> `;
// Exports
export default code;